module.exports = __webpack_public_path__ + "static/media/effect-03.0f910803.png";